import { ApiClient, GetResponseType } from '@make-software/tg-mini-app-ui';

import { WITH_AUTH } from '@/shared';
import { PostOnboardingCompletedResponseType, GetUserResponseType } from '@/entities';

export const getUser = async (
  withBalances?: boolean,
  captchaToken?: string,
  tgInitData?: string
): Promise<GetResponseType<GetUserResponseType>> => {
  const headers: Record<string, string> = {};
  if (captchaToken) {
    headers['x-recaptcha'] = captchaToken;
  }
  const { data, error, loading, httpCode } = await ApiClient.get<GetUserResponseType>(
    `${window.config.api_endpoint}/users/me?includes=csprname${withBalances ? ',balances' : ''}`,
    tgInitData || WITH_AUTH,
    headers
  );

  return {
    data,
    httpCode,
    error,
    loading
  };
};

export const completeOnboarding = async (): Promise<
  GetResponseType<PostOnboardingCompletedResponseType>
> => {
  const { data, error, loading, httpCode } =
    await ApiClient.post<PostOnboardingCompletedResponseType>(
      `${window.config.api_endpoint}/users/me/onboarding-completed`,
      {},
      WITH_AUTH
    );

  return {
    data,
    httpCode,
    error,
    loading
  };
};

export const markInstallToHomeScreenCompleted = async (): Promise<GetResponseType<any>> => {
  const resp = await ApiClient.post<any>(
    `${window.config.api_endpoint}/users/me/install-to-home-screen/complete`,
    {},
    WITH_AUTH
  );

  return resp;
};
